import { ApolloClient, NormalizedCacheObject, useMutation, useQuery } from '@apollo/client';
import { CreateLinkData, LessonLinkData, LessonLinkVars } from '../gql-types';

import ApolloClientService from '../../shared/services/ApolloClientService';
import Config from '../../shared/config';
import ContentGraphQL from '../gql';

let contentApolloClient: ApolloClient<NormalizedCacheObject> = null;

export const useLessonLink = (modulekey: number) => {
  if (!contentApolloClient) {
    contentApolloClient = ApolloClientService.create(Config.CONTENT_GQL);
  }

  const { loading, error, data } = useQuery<LessonLinkData, LessonLinkVars>(
    ContentGraphQL.Query.FETCH_LINKS,
    {
      client: contentApolloClient,
      fetchPolicy: 'network-only',
      variables: {
        modulekey
      }
    }
  );

  const [_createLink, { loading: creating }] = useMutation<
    CreateLinkData,
    LessonLinkVars
  >(ContentGraphQL.Mutation.CREATE_LINK, {
    client: contentApolloClient,
    refetchQueries: [
      {
        query: ContentGraphQL.Query.FETCH_LINKS,
        variables: {
          modulekey
        }
      }
    ],
    awaitRefetchQueries: true
  });

  const createLink = async (linkVariables: LessonLinkVars) => {
    const { data } = await _createLink({
      variables: linkVariables
    });
    return data.lessonLink;
  };

  const [_deleteLink, { loading: deleting }] = useMutation<LessonLinkVars>(
    ContentGraphQL.Mutation.DELETE_LINK,
    {
      client: contentApolloClient,
      refetchQueries: [
        {
          query: ContentGraphQL.Query.FETCH_LINKS,
          variables: {
            modulekey
          }
        }
      ],
      awaitRefetchQueries: true
    }
  );

  const deleteLink = (linkkey: string) => {
    _deleteLink({
      variables: { linkkey }
    });
  };

  return {
    loading,
    error,
    creating,
    deleting,
    links: data?.links,
    createLink,
    deleteLink
  };
};
